import qs from 'qs'
import axios from 'axios'
import { Loading, MessageBox } from 'element-ui'
import route from '@/router/index'
function delParam (paramKey) {
  let url = window.location.href // 页面url
  const urlParam = window.location.search.substr(1) // 页面参数
  const beforeUrl = url.substr(0, url.indexOf('?')) // 页面主地址（参数之前地址）
  let nextUrl = ''
  let arr = []
  if (urlParam !== '') {
    const urlParamArr = urlParam.split('&') // 将参数按照&符分成数组
    for (var i = 0; i < urlParamArr.length; i++) {
      const paramArr = urlParamArr[i].split('=') // 将参数键，值拆开
      // 如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i])
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&')
  }
  url = beforeUrl + nextUrl
  return url
}
export default function fetch ({
  method = 'get',
  url,
  data,
  params,
  isJSON = true,
  responseType,
  useLoading = true,
  isReturntype = false,
  isLogin = false
}) {
  let loading
  if (useLoading) {
    loading = Loading.service({
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.5)'
    })
  }
  let option = {
    method,
    url,
    data: isJSON ? data : qs.stringify(data),
    params,
    responseType: responseType || 'json'
  }
  const token = localStorage.getItem('token')
  if (token) {
    option.headers = {
      Authorization: `Bearer ${token}`
    }
  }

  return axios(option)
    .then(function ({
      data
    }) {
      if (loading) {
        loading.close()
      }
      let code = parseInt(data.code)
      if (isReturntype) {
        return data
      } else {
        if (code === 1000 || code === 200) {
          return data.data
        } else {
          if ((code === 4001 || code === 4002) && isLogin) {
            const erreData = data?.data ?? {}
            route.app.$router.push({
              name: 'noAuthority',
              query: option.url.includes('loginByCode') ? {
                mobile: option.data.mobile,
                loginCode: code
              } : {
                email: erreData.email,
                mobile: erreData.mobile,
                userName: erreData.userName,
                loginCode: code
              }
            })
            throw {
              code: code,
              message: data.msg || '操作失败'
            }
          } else if (code === 4010 && isLogin) {
            window.location = `http://wx.coocaa.com/weixin.htm?appid=wxc1d38a25a66befce&redirect_uri=${encodeURIComponent(delParam('code'))}&scope=snsapi_base#wechat_redirect&response_type=code&state=`
          } else if (code === 4000 && !option.url.includes('loginByCode')) {
            localStorage.removeItem('token')
            route.app.$router.push({
              name: 'login',
              query: {
                redirect: `${window.location.pathname}${window.location.search}`
              }
            })
          } else {
            if (code === 1002) {
              setTimeout(() => {
                window.location = `/`
              }, 1000)
            }
            // eslint-disable-next-line no-throw-literal
            throw {
              code: code,
              message: data.msg || '操作失败'
            }
          }
        }
      }
    })
    .catch(e => {
      if (loading) {
        loading.close()
      }
      if (e.code === 40001) {
        option.headers = {
          tokenId: ''
        }
        this.app.$logout().then(() => {
          this.app.$router.push({ name: 'login' })
        })
      } else {
        throw e
      }
    })
}
